import { RequestParams, WithPagination } from '@bv/api';

import type { FieldValue, FieldValues, SelectField, StepConfig } from '../../types/workflow';

class WorkflowsApi extends WithPagination {
  constructor() {
    super('flow/workflows');
  }
}

const workflowsApi = new WorkflowsApi();

let workflows = [] as Array<{ name: string; id: string; isActive: boolean; triggerType: string }>;

const workflowOptionsCache = async (config: { params?: RequestParams }) => {
  const { data, meta } = await workflowsApi.paginated({
    params: {
      'filter.triggerType': '$eq:InvokedInternally',
      ...config.params,
    },
  });
  const workflowsData = {
    meta,
    data: (data as Array<{ name: string; id: string; isActive: boolean; triggerType: string }>).map((wf) => ({
      label: `${wf.isActive ? '🟢' : '🔴'} ${wf.name}`,
      value: wf.id,
      isActive: wf.isActive,
    })),
  };
  workflows = [...data];
  return workflowsData;
};
const StartAnotherWorkflow: StepConfig = {
  // Design
  icon: 'startAnotherWorkflow',
  headerTextColor: '#011B4F',
  headerColor: '#D0D7E1',
  title: 'Start Another Workflow',
  text: 'Use Another Workflow',
  category: 'Node',
  desc: 'Choose the Trigger that will start this Workflow by another workflow.',
  primaryKey: (parentValues: Record<string, any>) => {
    if (!parentValues.workflowId) {
      return 'Not selected workflow.';
    }
    const name = parentValues.workflow?.name;
    const isActive = parentValues.workflow?.isActive;

    const statusText = isActive ? '🟢 Active' : '🔴 Inactive';
    return `Name: ${name}\nStatus: ${statusText}`;
  },
  canAdd: false,
  // Variable fields configuration
  // Form
  formFields: [
    {
      key: 'workflowId',
      label: 'Workflow',
      type: 'select',
      defaultValue: '',
      returnObject: false,
      validation: {
        required: true,
      },
      options: () => workflowOptionsCache,
      onChange: async (value: FieldValue, allValues: FieldValues) => {
        // Find the selected workflow from the cached workflows array
        const selectedWorkflow = workflows.find((wf) => wf.id === value);
        if (selectedWorkflow) {
          // Save only required fields (name and isActive) to workflow object
          (allValues as unknown as { workflow: { name: string; isActive: boolean } }).workflow = {
            name: selectedWorkflow.name,
            isActive: selectedWorkflow.isActive,
          } as unknown as { name: string; isActive: boolean };
        }
      },
    } as SelectField,
  ],
};

export default StartAnotherWorkflow;
